import actionTypes from '../actions/actionTypes'
import onboardingActivityViewStateTypes from 'helpers/enums/onboardingActivityViewStateTypes'

const defaultState = {
	lessonId: '',
	isDeleted: '1',
	customSlideId: '',
	parentCustomSlideId: '',
	jwt: '',
	viewState: onboardingActivityViewStateTypes.INITIAL,
	shouldShowBottomBar: false,
}

function setLessonData(state, action) {
	return {
		...state,
		lessonId: action.payload.presentationId,
		isDeleted: action.payload.isDeleted,
		customSlideId: action.payload.customSlideId,
		parentCustomSlideId: action.payload.parentCustomSlideId,
		jwt: action.payload.jwt,
	}
}

function setViewState(state) {
	return {
		...state,
		viewState: onboardingActivityViewStateTypes.SUBMITTING,
	}
}

function enableBottomBar(state) {
	return {
		...state,
		shouldShowBottomBar: true,
	}
}

function disableBottomBar(state) {
	return {
		...state,
		shouldShowBottomBar: false,
	}
}

function setViewInitialState(state) {
	return {
		...state,
		viewState: onboardingActivityViewStateTypes.INITIAL,
	}
}

const onboardingActivityReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.ONBOARDING_ACTIVITY_CREATE_LESSON_SUCCESS:
			return setLessonData(state, action)
		case actionTypes.ONBOARDING_ACTIVITY_ADD_ACTIVITY:
			return setViewState(state)
		case actionTypes.ONBOARDING_ACTIVITY_DEMO_CARD_POSTED:
			return enableBottomBar(state)
		case actionTypes.ONBOARDING_ACTIVITY_DEMO_COMPLETED:
			return disableBottomBar(state)
		case actionTypes.GOALS_COLLABORATE_CARD_CREATE_LESSON:
			return setViewInitialState(state)
		default:
			return state
	}
}

export default onboardingActivityReducer

export {
}
